<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
		/>

		<section class="main-content highlights-section background-light">
			<highlights-map :items="highlights" />
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			class="faq-section"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: highlights } = await useWebsiteFetch('highlights', {
	query: { language: locale.value },
	key: `${locale.value}/highlights`,
});
</script>

<style lang="scss" scoped>
.background-light {
	background: url('~/assets/images/shapes/contentblock-bg-pattern.png') repeat top left;
	overflow: hidden;
}

.highlights-nav {
	padding-right: 0;

	ul {
		margin: 10px 0 20px;
		padding: 0 0 0 20px;

		li {
			cursor: pointer;
		}
	}
}

.button-toggle {
	padding: 20px;
	transition: all 0.3s ease-in-out;
	width: 100%;
	text-align: left;
	background: #fff;
	color: var(--body-color);
	cursor: pointer;
	margin: 0;
	font-size: 14px;

	&:hover,
	&.active {
		background: var(--cta-color);
		color: #fff;
	}
}

.maps {
	background: #fff;
	padding: 20px;
}

#gmap {
	min-height: 600px;
}

@media (max-width: 920px) {
	.highlights-section .row {
		display: flex;
		flex-flow: column-reverse wrap;
	}

	.highlights-nav {
		width: 100%;
		padding: 0;
	}

	ul.highlights li {
		width: auto;
		margin: 1% 1% 1% 0;
	}
}
</style>
